import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.page.html',
  styleUrls: ['./subscribe.page.scss'],
})
export class SubscribePage implements OnInit {
  zones;
  zone;
  subscription;
  selected;
  subscriptionOptions;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.getZones();
    this.getSuscription();
  }

  select(zone) {
    this.selected = zone;
  }

  getSuscription() {
    this.authService
      .get('suscription')
      .then((res) => {
        console.log('Suscription: ', res);
        if (res.data) {
          this.subscription = res.data;
          this.zone = { id: res.data.zone_id, name: res.data.zone_name };
          if (this.zone && res.data.name.toLowerCase().indexOf('f') === 0) {
            this.zones = [this.zone];
            this.getOptions(this.zone.id);
          } else {
            this.getZones();
          }
        }
      })
      .finally(() => {});
  }

  getZones() {
    this.apiService
      .getData('zones')
      .then((res) => {
        console.log('zones: ', res);
        this.zones = res.data;
      })
      .finally(() => {});
  }

  getOptions(zoneId) {
    this.apiService
      .getData('suscription-transportec-options?zone_id=' + zoneId)
      .then((res) => {
        console.log('subscription options: ', res);
        this.subscriptionOptions = res.data;
      })
      .finally(() => {});
  }

  selectZone(selected) {
    if (selected) {
      this.zone = selected;
      this.selected = null;
      this.getOptions(selected.id);
    }
    console.log('zone: ', this.zone);
  }

  zoneCompare(a: { id: number }, b: { id: number }) {
    if (a.id === b.id) {
      return true;
    }
    return false;
  }

  next() {
    console.log('goSubscriptionPayment');
    this.dataService.setData('subscription-selection', this.selected);
    this.router.navigate(['/tecservice-transportec/transportec/subscribe/payment-method']);
  }
}
